module.exports = __webpack_public_path__ + "static/media/finity_logo.930afb00.svg";